class CartAjax {
  static async updateSection() {
    const container = document.querySelector('.cart-page__container');
    const sectionId = container.dataset.sectionId;
    container.style.opacity = '0.5';
    container.style.pointerEvents = 'none';
    
    try {
      const res = await fetch(`/?section_id=${sectionId}`);
      const text = await res.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const newContainer = html.querySelector('.cart-page__container');
      if (newContainer) container.innerHTML = newContainer.innerHTML;
    } catch (err) {
      console.error('Cart update failed', err);
    } finally {
      container.style.opacity = '1';
      container.style.pointerEvents = 'auto';
    }
  }

  static async changeQty(key, qty) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: String(key), quantity: qty })
    });
    await this.updateSection();
  }

  static async addItem(variantId) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    });
    await this.updateSection();
  }
}

// Global Event Delegation (Survives DOM re-renders)
document.addEventListener('click', (e) => {
  const qtyBtn = e.target.closest('.js-qty-btn');
  if (qtyBtn) {
    e.preventDefault();
    const input = qtyBtn.parentElement.querySelector('input');
    const key = input.dataset.key;
    let val = parseInt(input.value);
    if (qtyBtn.dataset.action === 'minus') val--;
    if (qtyBtn.dataset.action === 'plus') val++;
    CartAjax.changeQty(key, val);
  }
  
  const removeBtn = e.target.closest('.js-remove-btn');
  if (removeBtn) {
    e.preventDefault();
    CartAjax.changeQty(removeBtn.dataset.key, 0);
  }
});

document.addEventListener('change', (e) => {
  const fbtBox = e.target.closest('.js-fbt-checkbox');
  if (fbtBox) {
    if (fbtBox.checked) {
      CartAjax.addItem(fbtBox.value);
    } else {
      CartAjax.changeQty(fbtBox.dataset.key, 0);
    }
  }
});